import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const SelectPartsTracking = lazy(() => import('../../../../pages/SelectPartsTracking/SelectPartsTracking'));

export const Route = createFileRoute('/$lang/_authenticated/select-parts-tracking')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <SelectPartsTracking />
    </Suspense>
  ),
});
